import React from "react"

export default function Facebook() {
  return (
    <svg
      width="29"
      height="28"
      viewBox="0 0 29 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.6262 26.7249V15.1157H19.7519L20.3708 10.5901H15.6262V7.70116C15.6262 6.39129 16.0099 5.49863 18.0016 5.49863L20.5378 5.49765V1.44977C20.0992 1.39596 18.5937 1.27258 16.8414 1.27258C13.1823 1.27258 10.6772 3.38126 10.6772 7.25294V10.5901H6.53906V15.1157H10.6772V26.7249H15.6262Z"
        fill="#3870DE"
      />
    </svg>
  )
}
